import { render } from "./designOcr.vue?vue&type=template&id=a92223d8"
import script from "./designOcr.vue?vue&type=script&lang=js"
export * from "./designOcr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__